<div *ngIf="prepaidData" class="py-8">
  <div class="mx-4 shadow-xl rounded-lg flex flex-col" *ngIf="isLoggedIn">
    <!--Header-->
    <div class="bg-theme-primary rounded-t-xl h-14 flex items-center px-4 gap-3">
      <i class="font-bold text-xl text-theme-contrast fas fa-badge-percent"></i>
      <div class="flex-1 font-bold text-xl text-theme-contrast">{{config?.payment?.prepaid_name}}</div>
    </div>

    <!--Body-->
    <div class="flex-1 border-2 border-theme-primary flex flex-col items-center pt-10">
      <div class="p-1 border-8 rounded-lg border-theme-text" *ngIf="hasCard">
        <img class="w-40 h-40" src="https://steward.heynows.com/qr?content={{prepaidData.number}}&size=110&margin=1">
      </div>
      <div class="flex flex-row text-base items-center gap-2 mt-4">
        <i class="fas fa-coins"></i>
        <div class="font-bold">{{ hasCard ? getString("Saldo") : getString("Saldo saknas") }}</div>
      </div>
      <div *ngIf="hasCard">
        <div class="font-bold text-2xl">{{prepaidData.balance}}</div>
      </div>
      <div class="mt-8 mb-6">
        <app-light-icon-button [leftIcon]="'fa-plus-circle'" (onClick)="refill()" [text]="refillButtonTitle"></app-light-icon-button>
      </div>
    </div>

    <!--Footer-->
    <div class="bg-theme-primary rounded-b-lg h-14 px-8 justify-evenly flex-col flex font-bold text-theme-contrast items-end text-sm">
      <div *ngIf="hasCard">
        {{prepaidData.identity}}
      </div>
      <div *ngIf="hasCard">
        {{prepaidData.name}}
      </div>
    </div>
  </div>
</div>
<div *ngIf="!isLoggedIn" class="mb-4">
  <div class="font-bold text-lg mb-6 text-center">{{getString('Verifiera dig för att skaffa eller hantera rabattkort')}}</div>
  <app-action-button [text]="getString('Verifiera')" (onClick)="verify()"></app-action-button>
</div>
<div *ngIf="!prepaidData" class="h-[36rem] flex items-center justify-center">
  <app-loading-spinner></app-loading-spinner>
</div>

<!--<div class="">-->
<!--  <div *ngIf="prepaidData" class="container">-->
<!--    <div class="back" (click)="back()">-->
<!--      <mat-icon style="font-size: 27px">navigate_before</mat-icon>-->
<!--      <div style="margin: 3px 0 0 5px;">{{config?.payment?.prepaid_name}}</div>-->
<!--    </div>-->
<!--    <div class="card" *ngIf="prepaidData.identity">-->
<!--      <img src="https://storage.googleapis.com/heynow/media/logo_coral_100.png" class="logo-card">-->
<!--      <div *ngIf="prepaidData.number" style="position: relative; width: 100%; height: 0">-->
<!--        <div class="qr-thing"><a (click)="showQR()"><mat-icon *ngIf="!showQRCode" style="font-size: 33px;">qr_code_2</mat-icon><mat-icon *ngIf="showQRCode" style="font-size: 33px;">close</mat-icon></a></div>-->
<!--      </div>-->
<!--      <label>{{prepaidData.card_name}}</label>-->
<!--      <div id="user" class="cardnumber"><span>{{prepaidData.identity}}</span></div>-->
<!--      <table width="100%">-->
<!--        <tr>-->
<!--          <td><label>Name:</label></td>-->
<!--          <td><label>Balans:</label></td>-->
<!--        </tr>-->
<!--        <tr>-->
<!--          <td><div class="name">{{prepaidData.name}}</div></td>-->
<!--          <td><div class="ccv">{{prepaidData.balance}}</div></td>-->
<!--        </tr>-->
<!--      </table>-->
<!--      <div *ngIf="showQRCode" style="display:flex; flex-direction:column; align-items: center; margin-top: 16px;">-->
<!--        <img src="https://steward.heynows.com/qr?content={{prepaidData.number}}&size=120&margin=1">-->
<!--        <div class="under">ⓘ {{getString("Kan användas vid betalning i kassan")}}</div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->

<!--  <div *ngIf="prepaidData && !showQRCode && appState?.order.user_cfg.is_anon === false" style="margin-top: 32px;">-->
<!--    <div class="payment-button" mat-ripple (click)="refill()">-->
<!--      <div class="payment-button-text">{{getString("Fyll på kort med")}} {{prepaidData.formatted}}</div>-->
<!--    </div>-->
<!--  </div>-->

<!--  <div *ngIf="appState?.order.user_cfg.is_anon === true" style="margin-top: 32px;">-->
<!--    <div class="payment-button" mat-ripple (click)="login()">-->
<!--      <div class="payment-button-text">{{getString("Logga in för att fylla på kort")}}</div>-->
<!--    </div>-->
<!--  </div>-->

<!--  <div class="overlay" *ngIf="isLoading">-->
<!--    <div class="center">-->
<!--      <mat-progress-spinner mode="indeterminate" class="spinner">-->
<!--      </mat-progress-spinner>-->
<!--    </div>-->
<!--  </div>-->

<!--</div>-->
